import {HeadingProps} from 'react-markdown/lib/ast-to-react';

import {Text} from '#component/base';

import {heading1} from '../Markdown.css';

export const Heading1 = ({children}: React.PropsWithChildren<HeadingProps>) => {
  return (
    <Text as="h1" variant="heading3" fontWeight="medium" className={heading1}>
      {children}
    </Text>
  );
};
